// extracted by mini-css-extract-plugin
export default {"notes":"Notes_notes__aQh2G","toolBarButtons":"Notes_toolBarButtons__e3SSs"};